module.exports = __webpack_public_path__ + "media/images/top/reserved_pending_ov-0f6e1d450677bbf8e89c1bab86505c88.png";